import { createFileRoute } from '@tanstack/react-router'

import type { PerfilId } from '@/lib/visoes'

import { PaginaRegras } from '@/features/regras-processo/pagina'

export const Route = createFileRoute('/$perfil/regras/')({
  component: Tela,
})

function Tela() {
  const { perfil } = Route.useParams()
  return <PaginaRegras perfil={perfil as PerfilId} />
}
